import styled, { css } from 'styled-components';

export const ModalSubtitle = styled.p`
  margin: 4px 0 0;
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  line-height: 1.45;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  background: #ffffff;

  & + & {
    margin-top: 14px;
  }
`;

export const SectionHead = styled.header`
  display: flex;
  align-items: center;
  gap: 10px;

  .badge {
    width: 32px;
    height: 32px;
    border-radius: 10px;
    background: #e6f3ec;
    color: #006633;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.01em;
  }

  .subtitle {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: #64748b;
    font-weight: 500;
  }
`;

export const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const Label = styled.label`
  margin: 0;
  font-size: 11.5px;
  font-weight: 700;
  color: #475569;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const FieldHint = styled.span`
  font-size: 11.5px;
  color: #94a3b8;
  font-weight: 500;
  line-height: 1.4;
`;

const inputBase = css`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13.5px;
  color: #0f172a;
  background: #ffffff;
  font-family: inherit;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: #94a3b8;
  }

  &:focus {
    outline: none;
    border-color: #006633;
    box-shadow: 0 0 0 3px rgba(0, 102, 51, 0.12);
  }
`;

export const TextInput = styled.input`
  ${inputBase};
  height: 40px;
  padding: 0 12px;
`;

export const TextArea = styled.textarea`
  ${inputBase};
  min-height: 90px;
  resize: vertical;
  line-height: 1.5;
`;

export const Select = styled.select`
  ${inputBase};
  height: 40px;
  padding: 0 34px 0 12px;
  appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;
  cursor: pointer;
`;

export const FooterHint = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
  line-height: 1.45;

  svg {
    flex-shrink: 0;
    margin-top: 1px;
    color: #94a3b8;
  }
`;

export const DangerAlert = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  color: #7f1d1d;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;

  svg {
    flex-shrink: 0;
    margin-top: 1px;
  }
`;

export const FooterButton = styled.button<{
  $variant?: 'primary' | 'secondary' | 'danger';
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 38px;
  padding: 0 18px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.15s ease;

  ${({ $variant = 'primary' }) => {
    if ($variant === 'primary') {
      return css`
        background: #006633;
        color: #ffffff;
        border: 1px solid #006633;

        &:hover:not(:disabled) {
          background: #00451f;
        }
      `;
    }
    if ($variant === 'danger') {
      return css`
        background: #dc2626;
        color: #ffffff;
        border: 1px solid #dc2626;

        &:hover:not(:disabled) {
          background: #b91c1c;
        }
      `;
    }
    return css`
      background: #ffffff;
      color: #0f172a;
      border: 1px solid #e2e8f0;

      &:hover:not(:disabled) {
        background: #f8fafc;
        border-color: #006633;
        color: #006633;
      }
    `;
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
